import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useGroupJobProspectsState() {
  return useAppState();
}

export function useGroupJobProspectsActions() {
  const dispatch = useAppDispatch();

  function initializeState(groupId) {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      group: {
        id: groupId,
      },
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({
      ...appState,
      ...response,
      sortBy: appState.sortBy || null,
      sortDirection: appState.sortDirection || null,
      selectedJobProspectIds: [],
    }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function openJobClosedWarningModal(jobProspect) {
    dispatch((appState) => ({
      ...appState,
      jobClosedWarningModalIsOpen: true,
      jobClosedWarningForm: jobProspect,
    }));
  }

  function closeJobClosedWarningModal() {
    dispatch((appState) => ({
      ...appState,
      jobClosedWarningModalIsOpen: false,
      jobClosedWarningForm: null,
    }));
  }

  function openGenerateResumeModal(jobProspect) {
    dispatch((appState) => ({
      ...appState,
      generateResumeModalIsOpen: true,
      generateResumeJobProspect: jobProspect,
    }));
  }

  function closeGenerateResumeModal() {
    dispatch((appState) => ({
      ...appState,
      generateResumeModalIsOpen: false,
      generateResumeJobProspect: null,
    }));
  }

  function addGeneratingJobProspectId(jobProspectId) {
    dispatch((appState) => ({
      ...appState,
      generatingJobProspectIds: [...(appState.generatingJobProspectIds || []), jobProspectId],
    }));
  }

  function removeGeneratingJobProspectId(jobProspectId) {
    dispatch((appState) => ({
      ...appState,
      generatingJobProspectIds: (appState.generatingJobProspectIds || []).filter(id => id !== jobProspectId),
    }));
  }

  function setSortParams(sortBy, sortDirection) {
    dispatch((appState) => ({
      ...appState,
      sortBy,
      sortDirection,
    }));
  }

  function toggleJobProspectSelection(id) {
    dispatch((appState) => {
      const current = appState.selectedJobProspectIds || [];
      const updated = current.includes(id)
        ? current.filter(selectedId => selectedId !== id)
        : [...current, id];
      return { ...appState, selectedJobProspectIds: updated };
    });
  }

  function selectAllJobProspects(ids) {
    dispatch((appState) => ({
      ...appState,
      selectedJobProspectIds: ids,
    }));
  }

  function clearSelection() {
    dispatch((appState) => ({
      ...appState,
      selectedJobProspectIds: [],
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    clearFeedback,
    openGenerateResumeModal,
    closeGenerateResumeModal,
    openJobClosedWarningModal,
    closeJobClosedWarningModal,
    addGeneratingJobProspectId,
    removeGeneratingJobProspectId,
    setSortParams,
    toggleJobProspectSelection,
    selectAllJobProspects,
    clearSelection,
  };
}
